/**
 * Created by Jaroslav on 20/02/24.
 */

$('*[data-reveal-id="myModal-reports"]').on('click', function () {
    var source = $(this).data("reveal-source");
    var form_selector = '#myModal-reports form.wpcf7-form';
    $(form_selector + ' input[name="source"]').val(source);
    var props = $('.reports-forms-specials .' + source + ' .reports-forms-property');
    $(props).each(function (index) {
        if ($(this).text())
            $('#myModal-reports .' + $(this).data("property-name")).html($(this).html());
        else
            $('#myModal-reports .' + $(this).data("property-name")).html('');

        if ($(this).data("property-name") == 'reports_form_submit' && $(this).text())
            $(form_selector + ' input[type="submit"]').val($(this).text());

    });
});